/* eslint-disable @typescript-eslint/no-require-imports */
import React from 'react';
import { Image, Platform, View ,} from 'react-native';
import { buttonsStyles } from '../../Button/boutonStyle';
import { styles } from '../HeaderScreen/styles';
import Label from '../../Label';

export const Header = () => {

    return (
        <View >
            {Platform.OS !== 'web' && <View style={buttonsStyles.displayCenterInscriptionImage}>
                <Image
                    style={[styles.ImageInscr]}
                    source={require('../../../../ressources/images/LogoAro.png')}
                />
            </View>
            }
            <View
                style={{
                    justifyContent: 'center',
                    paddingBottom: 8,
                    marginTop: 30,
                }}>
                <Label
                    title="Veuillez remplir les champs"
                    type="titleGreenCenter"
                />
            </View>
        </View>
    )
}